<template>
  <el-dialog title="审批" class="global-dialog" :visible.sync="showDlg" width="600px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        :rules="rules" ref="form2" label-width="120px">
        <el-row>

          <el-col :span="24"  >
            <el-form-item prop="applyResult" label="申请结果">

              <el-select v-model="formData.applyResult" clearable  placeholder="请选择申请结果">
                <el-option v-for="(item, index) of resultArr" :value="item.value" :label="item.label"
                  :key="index"></el-option>

              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span="24"  >
            <el-form-item prop="approvalContent" label="审批意见">

              <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入审批意见"
                v-model="formData.approvalContent">
              </el-input>
            </el-form-item>

          </el-col>
        </el-row>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>

  </el-dialog>
</template>
<script>

export default {
  props: {
    innovationId: {
      type: String,
      default: ''
    },
    showDlg: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {

      formData: {
        applyResult: '',
        approvalContent: '',
        innovationId: ''

      },
      rules: {
        applyResult: [
          {
            required: true,
            message: '请选择申请结果',
            trigger: ['blur', 'change']
          }
        ],
        approvalContent: [
          {
            required: true,
            message: '请输入审批意见',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false,
      resultArr: [
        {
          label: '通过',
          value: '1'
        },
        {
          label: '不通过',
          value: '2'
        }

      ]
    }
  },
  computed: {

  },
  created () {
  },
  methods: {
    handleClose() {
      this.$emit('update:showDlg', false)
    },
    submitDlg () {
      this.$refs.form2.validate().then(() => {
        console.log(this.formData)
        this.loading = true

        const url = this.$apis.technologicalInnovation.approvalPaTechInnovation
        this.$axios.post(url, { ...this.formData, innovationId: this.innovationId }).then(() => {
          this.$emit('successSave')
          this.handleClose()
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

</style>
